var StitchServiceClientImpl = (function () {
    function StitchServiceClientImpl(proxy) {
        this.proxy = proxy;
    }
    StitchServiceClientImpl.prototype.callFunction = function (name, args, codec) {
        return this.proxy.callFunction(name, args, codec);
    };
    return StitchServiceClientImpl;
}());
export default StitchServiceClientImpl;
//# sourceMappingURL=StitchServiceClientImpl.js.map